var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.stats),function(stat,i){return _c('div',{key:stat.key},[(i !== 0)?_c('hr',{staticClass:"my-5"}):_vm._e(),_c('StatsTable',{attrs:{"stat_key":stat.key,"stat_title":stat.title}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }